import { parseStringTimerangeFilterValue } from "components/common/EntityFilters/helpers/timeRange";
const parseTimerangeFilter = (timestamp, defaultTimerange) => {
  if (!timestamp) {
    return defaultTimerange;
  }
  return parseStringTimerangeFilterValue(timestamp);
};
export default parseTimerangeFilter;
